export const xAxisRangeOptions = {
  type: 'datetime',
  position: 'bottom',
  axisBorder: {
    show: true,
  },
  axisTicks: {
    show: false,
  },
  tooltip: {
    enabled: false,
  },
  labels: {
    show: true,
  },
};

export const xAxisHourOptions = {
  type: 'numeric',
  position: 'bottom',
  tickAmount: 23,
  axisBorder: {
    show: true,
  },
  axisTicks: {
    show: false,
  },
  tooltip: {
    enabled: false,
  },
  labels: {
    show: true,
    formatter: function (value: any) {
      return parseInt(value).toFixed(0);
    },
  },
};
